import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client'

// For client-side requests, using Next.js API route that proxies to notification service
const httpLink = createHttpLink({
  uri: '/api/notifications/graphql',
})

// Notification preference/snooze types have no `id`/`_id` field in the
// notification-service schema, so InMemoryCache already can't normalize
// them — this makes that explicit instead of accidental. FcmToken is left
// out on purpose: it does have `id`, and normalizing it is correct.
const cache = new InMemoryCache({
  typePolicies: {
    NotificationPreference: { keyFields: false },
    NotificationSnoozePreference: { keyFields: false },
    NotificationSnoozeResult: { keyFields: false },
  },
})

const client = new ApolloClient({
  link: httpLink,
  cache,
})

export default client
